package com.milta.core.network

/**
 * MIL-97 — 403 `error.optimization_quota_exceeded` on an explicit optimization call
 * (`routes/{id}/optimize`, `routes/{id}/reoptimize-in-place`, `route-batches/{id}/reoptimize`).
 * Carries the ProblemDetails extensions so the screen can say when the counter resets, instead of
 * the generic 403 "not allowed" message. [resetAt] is the ISO instant, as sent by the API.
 */
class OptimizationQuotaExceededException(
    val limit: Int?,
    val remaining: Int?,
    val resetAt: String?,
) : ApiException(HTTP_FORBIDDEN, CODE) {
    companion object {
        const val CODE = "error.optimization_quota_exceeded"
        private const val HTTP_FORBIDDEN = 403
    }
}

/** True for the quota 403, whatever exception class carried it. */
val Throwable.isOptimizationQuotaExceeded: Boolean
    get() = this is ApiException && message == OptimizationQuotaExceededException.CODE
